var map = {
	"./duanwuBg1.png": "NvwF",
	"./duanwuBg2.png": "OrF9",
	"./duanwuBg3.png": "+1yT",
	"./duanwuBg4.png": "sUV0",
	"./duanwuBg5.png": "+zD6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RSM2";